import { useEffect, useState } from "react";
import { apiFetchPublic } from "../lib/api";
import { bestYoutubeThumbnailUrl } from "../lib/youtube";

/** @typedef {{
 *   id: number,
 *   youtubeVideoId: string,
 *   title: string,
 *   description: string,
 *   thumbnailUrl?: string | null,
 *   channelTitle?: string,
 *   publishedAt?: string | null,
 *   durationSeconds?: number | null,
 *   durationLabel?: string,
 *   publishedLabel?: string,
 *   category?: string,
 *   featuredSlot?: number | null,
 *   sortOrder?: number,
 * }} VideoRecord */

/** @param {VideoRecord} video */
export function videoToFilm(video) {
  const thumbnailUrl = bestYoutubeThumbnailUrl(video.youtubeVideoId, video.thumbnailUrl);
  return {
    id: String(video.id),
    youtubeVideoId: video.youtubeVideoId,
    cat: video.category || video.channelTitle || "Video",
    title: video.title,
    img: thumbnailUrl,
    thumbnailUrl,
    date: video.publishedLabel || "",
    dur: video.durationLabel || "",
    secs: video.durationSeconds || 0,
    dek: video.description || "",
  };
}

/** @returns {{ videos: ReturnType<typeof videoToFilm>[], loading: boolean }} */
export function useVideos() {
  const [videos, setVideos] = useState(/** @type {ReturnType<typeof videoToFilm>[] | null} */ (null));

  useEffect(() => {
    let cancelled = false;

    async function loadVideos() {
      try {
        const body = await apiFetchPublic("/videos");
        const records = body.data?.videos || [];
        if (!cancelled) {
          setVideos(records.map(videoToFilm));
        }
      } catch {
        if (!cancelled) {
          setVideos([]);
        }
      }
    }

    void loadVideos();

    return () => {
      cancelled = true;
    };
  }, []);

  return {
    videos: videos ?? [],
    loading: videos === null,
  };
}
